import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../../shared/services/modal.service';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

@Component({
  selector: 'app-ai-chat-widget',
  standalone: true,
  imports: [CommonModule, WidgetEdit, CdkOverlayOrigin],
  templateUrl: './ai-chat-widget.html',
  styleUrl: './ai-chat-widget.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatWidgetComponent {
  @Input() isEditMode: boolean = false;/*14-12-2025*/
  @Input() isAddMode: boolean = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() aiName: string = 'Charles';
  @Input() message: string = 'Consider pausing Disney+';
  @Input() savingAmount: string = '₹799/mo';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'small';

  @Input() index = 0;
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;
  @Input() title = 'AI Chat';

  constructor(private modalService: ModalService) { }

  openAiChatModal() {
    if (this.isEditMode || this.isAddMode) return;
    this.modalService.openAiChatModal();
  }
}
